/**
 * AI Assistant Button
 *
 * Button for the TopBar that opens the AI Assistant drawer.
 */

import React from 'react';
import { observer } from 'mobx-react-lite';
import { IconButton, Tooltip } from '@mui/material';
import { useRootStore } from '../../store/contexts';

export const AiAssistantButton: React.FC = observer(() => {
  const { aiAssistantStore } = useRootStore();

  const handleClick = () => {
    aiAssistantStore.toggle();
  };

  return (
    <Tooltip title="iO — Motor de consultas">
      <IconButton
        onClick={handleClick}
        aria-label="Abrir iO"
        sx={{ p: 0.5 }}
      >
        <img
          src="/IO.png"
          alt="iO"
          style={{ width: 28, height: 28, objectFit: 'contain' }}
        />
      </IconButton>
    </Tooltip>
  );
});

export default AiAssistantButton;
